import { HST_ERROR_CODES } from "@infinitaslearning/module-he-common";
import { redirectToIdpLogout } from "_helpers/utils/idp";
import { buildUrlWithPathParams } from "_helpers/utils/urlBuilder";
import type { AxiosError, AxiosResponse } from "axios";
import { PRODUCT_PAGES_ROUTES } from "constants/routes";
import { type ApiRequestError, RequestError, type RequestErrorModel } from "models/error/Error";
import { clearCookiesLogout, clearUsetifulUserDataOnLogout } from "persistence/access";

export function handlingResponse<T>(
  successStatus = [200],
  errorMessage = "Error",
  type = "",
): (response: AxiosResponse) => T {
  return function axiosResponse(response: AxiosResponse): T {
    if (!successStatus.includes(response.status)) {
      throw new RequestError({ message: errorMessage, status: response.status, type });
    }
    return response.data as T;
  };
}

export const logError = (
  error: AxiosError<ApiRequestError>,
  useLogoutHandler = true,
): RequestErrorModel => {
  const { data, status } = error.response || {};

  if (useLogoutHandler && status === 401) {
    clearCookiesLogout();
    clearUsetifulUserDataOnLogout();
    redirectToIdpLogout(window.location.pathname);
  }

  // Redirect user to license expired page if they're trying to fetch data on a product
  // for which their license is no longer active
  if (status === 403 && data?.extra?.errCode === HST_ERROR_CODES.EXPIRED_PRODUCT_LICENSE) {
    // Extract product id from the error message (ex.: "User X has an uninitiated license for product XX")
    const [errMessageProductPart] = data?.message.match(/product [0-9]+/g) || [];
    const [, productId] = errMessageProductPart?.split(" ") || [];
    window.location.href = buildUrlWithPathParams(PRODUCT_PAGES_ROUTES.EXPIRED_LICENSE, {
      productId,
    });
  }

  return {
    errCode: data?.extra?.errCode,
    extra: data?.extra,
    message: data?.message || "",
    status: status || 500,
    type: data?.type || "",
  };
};
